import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ReasonGroupService } from '../proxy/general/controllers/reason-group.service';

FieldBuilder.setNamespace('General');

export const REASON_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Reason.Name')
    .required()
    .minLength(1)
    .maxLength(55)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Reason.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('reasonGroupBiId', 'Entity.Reason.ReasonGroupBi', ReasonGroupService)
    .displayFromNested('reasonGroupBi.name')
    .sortBy('reasonGroupBi.name')
    .build(),
  FieldBuilder
    .checkbox('isVisible', 'Entity.Reason.IsVisible')
    .build(),
  FieldBuilder
    .checkbox('isProductive', 'Entity.Reason.IsProductive')
    .build(),
  FieldBuilder
    .checkbox('isForDisableResourceTemporarily', 'Entity.Reason.IsForDisableResourceTemporarily')
    .build(),
  FieldBuilder
    .checkbox('isEnabledForLiquidation', 'Entity.Reason.IsEnabledForLiquidation')
    .build(),
  FieldBuilder
    .checkbox('canDeprocessHarvestActivityReport', 'Entity.Reason.CanDeprocessHarvestActivityReport')
    .build(),
  FieldBuilder
    .foreignKey('reasonGroupId', 'Entity.ReasonGroup', ReasonGroupService)
    .required()
    .displayFromNested('reasonGroup.name')
    .sortBy('reasonGroup.name')
    .build(),
];

export const REASON_CONFIG = {
  entityName: 'Reason',
  localizationKey: 'General::Entity.Reason',
  fields: REASON_FIELDS,
  permission: 'ControllingActivities.Reasons',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
